import React from 'react';
import {Edit} from 'react-admin';
import {BankBinForm} from './BankBinForm';

export const BankBinEdit = (props: unknown): React.ReactElement => <Edit {...props}>
    <BankBinForm {...props}/>
</Edit>;

